import React, { PureComponent } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogActions, DialogContentText } from '@mui/material';
import VaultButton from './VaultButton';

export interface IConfirmDialogResult {
  confirmed: boolean
}

export interface IProps {
  onResult: (result: IConfirmDialogResult) => void,
  open: boolean,
  title?: string,
  message?: string
}

const DEFAULT_TITLE = 'Confirm action.';
const DEFAULT_MESSAGE = 'Are you sure you wish to proceed with the action?';

class ConfirmDialog extends PureComponent<IProps> {
  handleConfirm = () => {
    this.props.onResult({ confirmed: true });
  };

  handleCancel = () => {
    this.props.onResult({ confirmed: false });
  };

  render() {
    const {
      title = DEFAULT_TITLE,
      message = DEFAULT_MESSAGE,
    } = this.props;

    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleCancel}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <VaultButton
            data-auto="CancelBtn"
            onClick={this.handleCancel}
            variant="plainOnWhite"
          >
            Cancel
          </VaultButton>
          <VaultButton
            data-auto="ConfirmBtn"
            onClick={this.handleConfirm}
            variant="primaryOnWhite"
          >
            Confirm
          </VaultButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ConfirmDialog;
